import { addProps, flowMax } from 'ad-hok'
import { addAdminOrCreatorOrRedirect, addApi, addConfig } from 'shared/src/api'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { makeResources, resourceOrder } from '../components/resource'

const addResourceNames = flowMax(
  addAdminOrCreatorOrRedirect,
  addApi,
  addConfig,
  addTranslationHelpers,
  addProps(
    ({ user, api, config, t }) => {
      if (user.isAdmin) {
        return { resourceNames: resourceOrder }
      }

      const resources = makeResources(api, config, t)
      return {
        resourceNames: resourceOrder.filter(
          (name) => resources[name].availableToCreators
        ),
      }
    },
    ['user', 'api', 'config', 't']
  )
)

export default addResourceNames
